 const header = document.querySelector(".header-wrapper");

// Apply on window load
header.classList.add("transparent", "menu-white");

document.addEventListener("scroll", function () {
    if (!header) return;

    if (window.scrollY >= 100) {
        header.classList.add("fixed-header", "gradient");
        header.classList.remove("transparent", "menu-white"); 
    } else {
        header.classList.remove("fixed-header", "gradient");
        header.classList.add("transparent", "menu-white"); 
    }
});

// standalone menu
document.addEventListener('DOMContentLoaded', function () {

  /* ------------------------------
   * 1) Convert some mega menus into normal dropdowns
   * ------------------------------ */

  const standaloneMenus = [
    'Details-HeaderMenu-1',
    'Details-HeaderMenu-2',
    'Details-HeaderMenu-7',
    'Details-HeaderMenu-8',
    'Details-HeaderMenu-9'
  ];

  standaloneMenus.forEach(menuId => {
    const details = document.getElementById(menuId);
    if (!details) return;

    // Switch classes
    details.classList.remove('mega-menu');
    details.classList.add('header__submenu');

    const megaContent = details.querySelector('.mega-menu__content');
    if (!megaContent) return;

    // Create Dawn-style dropdown UL
    const dropdownList = document.createElement('ul');
    dropdownList.className =
      'header__submenu list-menu list-menu--disclosure motion-reduce';
    dropdownList.setAttribute('role', 'list');

    /*
     * NEW LOGIC:
     * Collect ALL first-level <li> inside mega menu
     * (both left + right columns)
     */
    const allTopLevelLis = megaContent.querySelectorAll(
      '.mega-menu__column ul > li'
    );

    allTopLevelLis.forEach(li => {
      dropdownList.appendChild(li);
    });

    // Replace mega content entirely
    megaContent.replaceWith(dropdownList);
  });

  /* ------------------------------
   * 2) Shared behavior (UNCHANGED)
   * ------------------------------ */

  const allDetails = Array.from(
    document.querySelectorAll('details[id^="Details-HeaderMenu-"]')
  );

  allDetails.forEach(details => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        allDetails.forEach(other => {
          if (other !== details) other.open = false;
        });
      }
    });
  });

  const canHover = window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    allDetails.forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('mouseenter', () => {
        if (!details.open) details.open = true;
      });
    });
  }

  const headerRoot =
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  function isOutsideMenusAndHeader(target) {
    if (target.closest('details[id^="Details-HeaderMenu-"]')) return false;
    if (headerRoot && headerRoot.contains(target)) return false;
    return true;
  }

  document.addEventListener('click', (e) => {
    if (isOutsideMenusAndHeader(e.target)) {
      allDetails.forEach(d => (d.open = false));
    }
  });

  if (canHover) {
    document.addEventListener('mouseover', (e) => {
      if (isOutsideMenusAndHeader(e.target)) {
        allDetails.forEach(d => (d.open = false));
      }
    });
  }
});



/*---------------------------- pagination logic -------------------*/ 
document.addEventListener("DOMContentLoaded", function () {
  const itemsPerPage = 10;
  const items = document.querySelectorAll(".js-item");
  const pagination = document.getElementById("jsPagination");
  const totalPages = Math.ceil(items.length / itemsPerPage);
  let currentPage = 1;

  function showPage(page) {
    currentPage = page;

    items.forEach((item, index) => {
      item.style.display =
        index >= (page - 1) * itemsPerPage &&
        index < page * itemsPerPage
          ? "grid"
          : "none";
    });

    document.querySelectorAll(".js-pagination button").forEach(btn => {
      btn.classList.remove("active");
    });

    document.querySelector(`[data-page="${page}"]`)?.classList.add("active");

    // Scroll to top on pagination change
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  function createPagination() {
    pagination.innerHTML = "";

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement("button");
      btn.textContent = i;
      btn.dataset.page = i;
      btn.onclick = () => showPage(i);
      if (i === 1) btn.classList.add("active");
      pagination.appendChild(btn);
    }
  }

  createPagination();
  showPage(1);
});






// refresh page on closing of this popup 
document.addEventListener('click', function(event) {
  // Check if the clicked element (or its closest parent) is the toggle button
  if (event.target.closest('.quick-add-modal__toggle')) {
    window.location.reload();
  }
});





const serviceablePincodes = {
   pincodes: [
 "400001", "400002", "400003", "400004", "400005", "400006", "400007", "400008", "400009", "400010", "400011", "400012", "400013", "400014", "400015", "400016", "400017", "400018", "400019", "400020", "400021", "400022", "400023", "400024", "400025", "400026", "400027", "400028", "400029", "400030", "400031", "400032", "400033", "400034", "400035", "400036", "400037", "400038", "400039", "400040", "400041", "400042", "400043", "400044", "400045", "400046", "400047", "400048", "400049", "400050", "400051", "400052", "400053", "400054", "400055", "400056", "400057", "400058", "400059", "400060", "400061", "400063", "400064", "400065", "400066", "400067", "400068", "400069", "400070", "400071", "400072", "400073", "400074", "400075", "400076", "400077", "400078", "400079", "400080", "400081", "400082", "400083", "400084", "400085", "400086", "400087", "400088", "400089", "400090", "400091", "400092", "400093", "400094", "400095", "400096", "400097", "400098", "400099", "400101", "400102", "400103", "400104", "400105", "400601", "400602", "400603", "400604", "400605", "400606", "400607", "400608", "400610", "400612", "400614", "400701", "400703", "400705", "400706", "400708", "400709", "400710", "110001", "110002", "110003", "110004", "110005", "110006", "110007", "110008", "110009", "110010", "110011", "110012", "110013", "110014", "110015", "110016", "110017", "110018", "110019", "110020", "110021", "110022", "110023", "110024", "110025", "110026", "110027", "110028", "110029", "110030", "110031", "110032", "110033", "110034", "110035", "110037", "110038", "110043", "110044", "110045", "110046", "110047", "110048", "110049", "110051", "110052", "110054", "110055", "110056", "110057", "110058", "110059", "110060", "110061", "110062", "110063", "110064", "110065", "110066", "110067", "110068", "110069", "110070", "110071", "110072", "110074", "110075", "110076", "110077", "110078", "110080", "110085", "110086", "110087", "110088", "110089", "110091", "110092", "110095", "110096", "110097", "121001", "121002", "121003", "121005", "121006", "121007", "121008", "121009", "121010", "121012", "121013", "122001", "122002", "122003", "122004", "122005", "122006", "122008", "122009", "122010", "122011", "122015", "122018", "201001", "201010", "201011", "201012"
   ]
};

/* ---------- FAST LOOKUP (O1) ---------- */
const pincodeSet = new Set(serviceablePincodes.pincodes);

document.addEventListener("DOMContentLoaded", function(){

    const checkBtn = document.getElementById("checkBtn");
    const inputField = document.getElementById("pincodeInput");
    const resultDiv = document.getElementById("result");

    /* ---------- BLOCK ALPHABETS WHILE TYPING ---------- */
    inputField.addEventListener("keypress", function(e){
        if(!/[0-9]/.test(e.key)){
            e.preventDefault();
        }
    });

    /* ---------- BLOCK PASTE TEXT ---------- */
    inputField.addEventListener("paste", function(e){
        e.preventDefault();
        let pasted = (e.clipboardData || window.clipboardData).getData('text');
        pasted = pasted.replace(/\D/g, '').slice(0,6);
        inputField.value = pasted;
    });

    /* ---------- MOBILE KEYBOARD FIX ---------- */
    inputField.addEventListener("input", function(){
        inputField.value = inputField.value.replace(/\D/g, '').slice(0,6);
    });

    function checkPincode(){

        let input = inputField.value.trim();

        /* Indian PIN format */
        const pincodeRegex = /^[1-9][0-9]{5}$/;

        if(input.length !== 6){
            resultDiv.className="error";
            resultDiv.innerHTML="Please enter a 6 digit PIN code.";
            return;
        }

        if(!pincodeRegex.test(input)){
            resultDiv.className="error";
            resultDiv.innerHTML="Invalid PIN code format.";
            return;
        }

        /* FAST MATCH */
        if(pincodeSet.has(input)){
            resultDiv.className="success";
            resultDiv.innerHTML=
            "Delivery available for this pincode.";
        }
        else{
            resultDiv.className="error";
            resultDiv.innerHTML=
            "Sorry, delivery is not available for this pincode.";
        }
    }

    /* Button Click */
    checkBtn.addEventListener("click", checkPincode);

    /* Enter Key */
    inputField.addEventListener("keydown", function(e){
        if(e.key === "Enter"){
            checkPincode();
        }
    });

});